import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import moment from 'moment/min/moment-with-locales';

//components
import withRemoveDialog from '~/hoc/withRemoveDialog';
import applicationRouter from '~/hoc/applicationRouter';
import DatePicker from '../../../components/DatePicker/DatePicker';
import CustomCheckbox from '../../../components/CustomCheckbox/CustomCheckbox';
import { MembersWidget } from '../../../components/GenericForm/Widgets/UsersWidget';

//elements
import CustomMultiSelect from '../../../elements/CustomMultiSelect';

//utils
import { longDateFormat } from '../../../utils/dateFormat';
import { translateLabels } from '../../../utils/commonMethods';

class AbsenceReportDownloadModal extends Component {
    state = {
        dateRange: { start: moment(new Date()).startOf('month'), end: moment(new Date()) },
        all_members: false,
        users: [],
        selectedAbsenceTypes: [],
    };

    componentDidMount() {
        const { dateRange } = this.state;
        this.props.handleDownloadFormInputChange('start', dateRange.start.format('YYYY-MM-DD'));
        this.props.handleDownloadFormInputChange('end', dateRange.end.format('YYYY-MM-DD'));
    }

    onSelect = (date, field) => {
        const dr = { ...this.state.dateRange };
        dr[field] = moment(date);
        if (field === 'start' && dr.start.isAfter(dr.end)) {
            dr.end = dr.start.clone();
        } else if (field === 'end' && dr.end.isBefore(dr.start)) {
            dr.start = dr.end.clone();
        }
        this.setState({ dateRange: dr }, () => {
            this.props.handleDownloadFormInputChange('start', dr.start.format('YYYY-MM-DD'));
            this.props.handleDownloadFormInputChange('end', dr.end.format('YYYY-MM-DD'));
        });
    };

    onCheckboxChange = (name, value) => {
        this.setState({ all_members: value });
        this.props.handleDownloadFormInputChange('all_members', value);
    };

    onMemberChange = (id, user) => {
        const users = user ? user.map((u) => u.value) : [];
        this.setState({ users });
        this.props.handleDownloadFormInputChange('users', users.join(','));
    };

    onAbsenceTypesChange = (selected, multiSelectOptions) => {
        const codes = selected.map(index => multiSelectOptions[index]?.code).filter(Boolean);
        this.setState({ selectedAbsenceTypes: selected });
        this.props.handleDownloadFormInputChange('types', codes.join(','));
    };

    render() {
        const { t } = this.props;
        const { client } = this.props.commonStore.config;
        const statuses = client ? client.data.extendedRules.absent_types : [];
        const dateTimeRules = client.data && client.data.dateTimeRules ? client.data.dateTimeRules : false;
        const multiSelectAbsenceTypesOptions = statuses.map((element, index) => ({
            value: index,
            code: element.code,
            label: element.name,
            key: element.name,
        }));
        translateLabels(multiSelectAbsenceTypesOptions, t, 'label');

        return (
            <>
                <div style={{ paddingBottom: '130px' }}>
                    <div style={{ display: 'flex' }}>
                        <div style={{ paddingRight: '20px' }}>
                            <label>{t('From')}</label>
                            <DatePicker
                                selected={this.state.dateRange.start.toDate()}
                                onChange={(date) => this.onSelect(date, 'start')}
                                dateFormat={longDateFormat(dateTimeRules)}
                            />
                        </div>
                        <div>
                            <label>{t('To')}</label>
                            <DatePicker
                                selected={this.state.dateRange.end.toDate()}
                                onChange={(date) => this.onSelect(date, 'end')}
                                dateFormat={longDateFormat(dateTimeRules)}
                                minDate={this.state.dateRange.start.toDate()}
                            />
                        </div>
                    </div>
                    {this.props.userStore.currentUser.user_type != 'member' && (
                        <div style={{ marginTop: '15px' }}>
                            <label>{t('Select Members')}</label>
                            <CustomCheckbox
                                label={t('All members/employees')}
                                onChange={(v) => this.onCheckboxChange('all_members', v)}
                                isChecked={this.state.all_members}
                                inline
                            />
                            <MembersWidget
                                isMulti
                                value={this.state.users}
                                placeholder={t('Select...')}
                                onChange={(id, user) => this.onMemberChange(id, user)}
                            />
                        </div>
                    )}
                    <div style={{ marginTop: '5px' }}>
                        <label>{t('Absence types')}</label>
                        <CustomMultiSelect
                            className="custom-multi-select-max-height-100"
                            options={multiSelectAbsenceTypesOptions}
                            value={this.state.selectedAbsenceTypes}
                            onChange={(selected) => this.onAbsenceTypesChange(selected, multiSelectAbsenceTypesOptions)}
                            overrideStrings={{
                                search: t('Search'),
                                selectAll: t('Select All'),
                                allItemsAreSelected: t('All absence types selected'),
                            }}
                        />
                    </div>
                </div>
            </>
        );
    }
}
export default inject(
    'authStore',
    'absenceStore',
    'userStore'
)(applicationRouter(withRemoveDialog(observer(AbsenceReportDownloadModal))));
